import { render } from "./ActivationPrompt.vue?vue&type=template&id=2bb44a8e&ts=true"
import script from "./ActivationPrompt.vue?vue&type=script&lang=ts"
export * from "./ActivationPrompt.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__